import React from "react";
import { Link, DisabledPrompt, useModel, useParams, useRoute, useBCMSContext, BCMSRecord } from "@bcm-dev/bcms-vite";
import Classes, { Card } from "model";

import "./styles.css";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";

/**
 * @function SentCardToAddressView
 * @return {React.Component}
 * @exported true
 * @description The main component for SentCardToAddressView
 */
export default function SentCardToAddressView(props) {
  const { user, branding } = useModel();
  const navigate = useRoute();
  const controller = useBCMSContext();

  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);

  const cancelBtn = evt => navigate(`/home/recenttransactions/${ cardID }`);
  const nextBtn = evt => {
    BCMSRecord.batch([
      Card.update({ ...card.record, isOn: false })
    ], controller, Classes);

    navigate(`/home/reportloststolen/cardonitsway/${ cardID }`);
  };

  return (
    <div className="sent-card-to-address-view text-center">
      <p>You new card will be sent to the address we have on our records.</p>
      <div className="address-container">
        <p>{ user.name }</p>
        <p>{ user.street },</p>
        <p>{ user.city },</p>
        <p>{ user.state } - { user.zip }</p>
      </div>
      <p>Has your address changed? <DisabledPrompt><Link>Contact Us</Link></DisabledPrompt></p>
      <p>Your card will be disabled and can no longer be used for new purchases once you continue to report it.</p>
      <UIPrimaryButton text="Next" onClick={ nextBtn } />
      <UICancelButton text="Cancel" onClick={ cancelBtn } />
    </div>
  );
}